import styled from '@emotion/styled';

export const TransparentBackground = styled.div`
  position: fixed;
  top: var(--header-height);
  left: 0;
  width: 100%;
  height: 100%;
  z-index: var(--zindex-notification-center);
`;
